exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tituloBold>thead>tr>td[data-v-a1af0b68]{font-weight:500}.floatThead-container[data-v-a1af0b68],.floatThead[data-v-a1af0b68]{table-layout:auto!important;min-width:100%!important;max-width:100%!important;width:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1af0b68","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/FloatThead/FloatThead.vue
// module id = 266
// module chunks = 135